<div class="preProductionDiv">
  <div class="title">
    <span class="pe-1 material-icons">note_alt</span>
    <div class="title-text">
      Pre-Production Part/Vehicle
    </div>

    <div class="ml-auto" (click)="close()"><span class="material-icons">close</span></div>
  </div>
  <div class="body">
    <form [formGroup]="formGroup" *ngIf="!showLoader"> 
      <div class="form-group pb-2">
        <div class="postion-relative">
          <mat-form-field class="black-field uniform-input" [ngClass]="{ 'label-disable': isFormDisabled }">
              <mat-label class="label-text" >
                Return Date <span class="mandatory-field"></span>
              </mat-label>
              <input matInput [matDatepicker]="picker2" formControlName="scrapReturnDate">
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="form-group pb-2">
        <div class="position-relative">
          <mat-form-field class="black-field uniform-input" [ngClass]="{ 'label-disable': formGroup.get('preProductionStatus')?.disabled}">
            <mat-label class='label-text'>
              Current Status <span class="mandatory-field"></span>
            </mat-label>
            <mat-select (selectionChange)="scrapProof()"
                                                  disableOptionCentering
                                                  panelClass='panelClass'
                                                  formControlName='preProductionStatus'>
                                        <mat-option value="Returned to Tradezone">Returned to Tradezone</mat-option>
                                        <mat-option value="Scrapped">Scrapped</mat-option>
                                        <mat-option value="Pending">Pending</mat-option>
                          </mat-select>
          </mat-form-field>
        </div>
      </div>
      </form>
       <div class="loader" *ngIf="showLoader">
            <ngx-spinner [name]="spinner1" bdColor="rgba(0,0,0,0)" size="default" color="red" type="ball-elastic-dots"
                [fullScreen]="false">
            </ngx-spinner>
        </div>

  <div class="footer mt-2">
    <div><textarea id="commentBox" rows="4" cols="49" placeholder="Comments" [(ngModel)]="comments" [disabled]="isFormDisabled"></textarea></div>

    <div class="pt-2" *ngIf="(formGroup.get('preProductionStatus')?.value === 'Scrapped' || formGroup.get('preProductionStatus')?.value === 'Returned to Tradezone') && !isFormDisabled">
      <span class="attach">
        Please attach proof of scrap or returned to tradezone
      </span><span class="red">*</span>
      <div class="pt-2 pl-1"> 
        <label class="custom-file-upload" data-toggle="modal" data-target="#attachment"> Attach Files </label>
      </div>
    </div>

    <div *ngIf="filesList.length > 0"> 
      <ul class="uploaded-file-list">
        <li *ngFor="let file of filesNameList" class="uploaded-file">
          <span class="attachmentFiles" style="cursor: pointer; color: #007bff;" title="Click to download" (click)="downloadFile(file)">   
            {{file.filename || file }} 
          </span> &nbsp; <span><b>(Added at creation)</b></span>
        </li>
        <li *ngFor="let file of preprodNameList" class="uploaded-file">
          <span class="attachmentFiles" style="cursor: pointer; color: #007bff;" title="Click to download" (click)="downloadFile(file)">   
            {{file.filename || file}}
          </span>
        </li>
      </ul>
    </div>


    <div class="mt-2 d-flex flex-row-reverse" *ngIf="status === 'Pending'">
        <button class="next-button"  [disabled]="isUpdateDisabled()" (click)="updatePreProductionData()">
          Update
        </button>
    </div>
  </div>
  </div>
</div>
<div class="modal fade text-dark" id="attachment" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered ">
        <div class="modal-content">
            <div class="modal-header">
                <div class="modal-title"><em class="material-icons matIconColor">file_upload</em>
                    Upload Documents
                </div>
            </div>
            <div class="modal-body">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12 col-lg-12 modalBody mb-3">
                          <div class="mb-3"><b>Please attach the picture of Pre-Production Part/Vehicle</b></div>
                            <div *ngIf="showAttachErrorMsg" style="color: #cc0000;">Attached file has size greater than
                                15MB</div>
                            <input type="file" #fileInput [(ngModel)]='attachedFile'
                                accept=".gif,.jpe,.jpg,.jpeg,.svg,.pdf,.doc,.docx,.pptx,.txt,.xlsx,.msg,.rar,.csv,.png,.ppt,.xls,.tif"
                                (change)="handleFileInput($event.target.files,'preprod')" multiple>
                            <div class="fileUploadInfo"><i>(File format should
                                    be .gif, .jpe, .jpg, .jpeg, .svg, .pdf, .doc, .docx, .pptx, .txt, .xlsx, .msg, .rar,
                                    .csv, .ppt, .xls, .png or .tif and File size should be <= 15 MB)</i>
                            </div>
                        </div>
                        <div *ngIf="preprodNameList.length > 0">
                          <div *ngFor="let name of preprodNameList" class="align-items-center">
                            <mat-checkbox (change)="attachmentSelect($event, name)"></mat-checkbox>
                            <span
                              class="attachmentFiles"
                              title="Click to download the file"
                              (click)="downloadFile(name)">
                              {{ sanitize(name.filename || name) }}
                            </span>
                          </div>
                        </div>
                        <div class="d-flex flex-row justify-content-center align-items-center mt-3">
                            <button type="button" class="next-button ml-4" data-dismiss="modal" (click)='attachFile()'
                                [disabled]="preprodNameList.length==0">
                                <div class="mx-auto">Ok</div>
                            </button>
                            <button type="button" class="next-button ml-4" data-dismiss="modal">
                                <div class="mx-auto">Cancel</div>
                            </button>
                            <button type="button" class="next-button ml-4" (click)="deleteAttachedFile()"
                                *ngIf="showAttachDeleteBtn">
                                <div class="mx-auto">Remove</div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>